<template>
  <q-page v-touch-swipe.horizontal="userHasSwiped">
    <transition :name="slideDirection" mode="out-in">
      <component :is="currentView" :transName="slideDirection">
      </component>
    </transition>
    <nav-btn v-if="showNav" :goPrev="goPrev" :goNext="goNext" />
  </q-page>
</template>
<style scoped>

</style>
<script type="text/babel">
import NavBtn from 'components/nav-btn.vue';
import CaseView from 'components/case-view.vue';
import DivisionView from 'components/division-view.vue';
import HospitalView from 'components/hospital-view.vue';
import InstrumentView from 'components/instrument-view.vue';
import PersonView from 'components/person-view.vue';

export default {
  name: 'switchview',
  components: {
    NavBtn,
    CaseView,
    DivisionView,
    HospitalView,
    InstrumentView,
    PersonView,
  },
  data() {
    return {
      slideDirection: 'slide-r',
    };
  },
  computed: {
    showNav() {
      return !!this.$route.meta.nav;
    },
    currentView() {
      if (this.$route.params.id[0] === 'c') return 'CaseView';
      else if (this.$route.params.id[0] === 'd') return 'DivisionView';
      else if (this.$route.params.id[0] === 'h') return 'HospitalView';
      else if (this.$route.params.id[0] === 'i') return 'InstrumentView';
      else if (this.$route.params.id[0] === 'p') return 'PersonView';
    },
  },
  mounted() {
    console.log('switchview mounted');
    document.addEventListener('keyup', this.keyNav);
  },
  beforeDestroy() {
    console.log('resultview beforeDestroy');
    document.removeEventListener('keyup', this.keyNav);
  },
  methods: {
    goNext() {
      console.log('goNext*******************************************************');
      this.slideDirection = 'slide-r';
      if (this.$store.state.next) this.$router.push(this.$route.path.slice(0, this.$route.path.lastIndexOf('/') + 1) + this.$store.state.next);
    },
    goPrev() {
      console.log('goPrev*******************************************************');
      this.slideDirection = 'slide-l';
      if (this.$store.state.prev) this.$router.push(this.$route.path.slice(0, this.$route.path.lastIndexOf('/') + 1) + this.$store.state.prev);
    },
    userHasSwiped(obj) {
      console.log('userHasSwiped', obj);
      if (obj.distance.x > 30 && obj.duration < 500) {
        if (obj.direction === 'left') this.goNext();
        if (obj.direction === 'right') this.goPrev();
      }
    },
    keyNav(e) {
      if (e.keyCode === 37) this.goPrev();
      if (e.keyCode === 39) this.goNext();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/switch-view.vue